// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useLocalStorage } from '@rehooks/local-storage';
import pick from 'lodash/pick';
var UI_FLAGS = 'ui-flags';
var initializeFlagsFromURL = function () {
    var _a;
    if (typeof window === 'undefined') {
        return;
    }
    var url = new URL(window.location.href);
    var enableFlag = url.searchParams.get('enable-ui-flag');
    var disableFlag = url.searchParams.get('disable-ui-flag');
    if (enableFlag !== null && disableFlag !== null) {
        return;
    }
    var flags = JSON.parse((_a = window.localStorage.getItem(UI_FLAGS)) !== null && _a !== void 0 ? _a : '{}');
    if (enableFlag !== null) {
        flags[enableFlag] = true;
    }
    if (disableFlag !== null) {
        if (enableFlag !== null) {
            pick(flags, [enableFlag]);
        }
        else
            flags = {};
    }
    window.localStorage.setItem(UI_FLAGS, JSON.stringify(flags));
};
initializeFlagsFromURL();
var useUIFeatureFlag = function (featureFlag, defaultValue) {
    var _a;
    if (defaultValue === void 0) { defaultValue = false; }
    var _b = useLocalStorage(UI_FLAGS, {}), flags = _b[0], setFlags = _b[1];
    var value = (_a = flags[featureFlag]) !== null && _a !== void 0 ? _a : defaultValue;
    var setFlag = function (flag) {
        var _a;
        setFlags(__assign(__assign({}, flags), (_a = {}, _a[featureFlag] = flag, _a)));
    };
    return [value, setFlag];
};
export default useUIFeatureFlag;
